/* eslint-disable camelcase */
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import queryString from 'query-string';
// utils
import { IConversationsTurnType } from '@newo/api/gateway';
import useConversationStore from '@/pages/Conversations/Conversations.store.ts';

const parseQueryParams = (searchParams: URLSearchParams) => {
    return queryString.parse(searchParams.toString(), {
        arrayFormat: 'bracket'
    });
};

const URLListener = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const { actsFilters, setActsFilters, setUserPersonaFilters } =
        useConversationStore(
            useShallow((state) => ({
                actsFilters: state.actsFilters,
                setActsFilters: state.setActsFilters,
                setUserPersonaFilters: state.setUserPersonaFilters
            }))
        );

    useEffect(() => {
        const {
            turn_type,
            session_id,
            event_idns,
            agent_persona_id,
            connectors,
            from_datetime,
            to_datetime
        } = parseQueryParams(searchParams);

        const filters = {
            turn_type: turn_type as IConversationsTurnType,
            event_idns: event_idns as string[],
            agent_persona_id: agent_persona_id as string,
            connectors: connectors as string[],
            from_datetime: from_datetime as string,
            to_datetime: to_datetime as string,
            session_id: session_id as string
        };

        setActsFilters(filters);
        setUserPersonaFilters(filters);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const { user_persona_id } = parseQueryParams(searchParams);
        setSearchParams(
            queryString.stringify(
                { user_persona_id, ...actsFilters },
                { arrayFormat: 'bracket' }
            )
        );
    }, [actsFilters, searchParams, setSearchParams]);
    return false;
};

export default URLListener;
